import React, {Component} from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import './Form.css';
import {Col, Container, Row, Modal} from "react-bootstrap";
import Select, { components } from 'react-select';
import {
    clearInsurancePlansArrayBeforeFetching,
    saveDataFromMainPageForm, sendContactInformation, sendContactInformationInternal
} from "../actions";
import {
    NATIONALITY_OPTIONS,
    AGE_OPTIONS,
    DESTINATION_COUNTRY_OPTIONS,
    INSURANCE_DURATION_OPTIONS
} from "./../globan-app-elements/global_selects_options";
import {Trans} from 'react-i18next';

import i18n from 'i18next';
// import expatLogo from "../../../assets/images/expat-logo.svg";

import {
    getAdultsAmount,
    textInputValidation
} from "./../globan-app-elements/global_helper_functions";
import Tooltip from "./GlobalComponents/Tooltip/Tooltip";
import {emailInputValidation} from "../globan-app-elements/global_helper_functions";
import InfoIcon from "./../assets/images/icons/info.svg"
import TitleIcon from "./../assets/images/icons/titleicon.svg"
import FormSelect from "./../assets/images/icons/form-select.svg"

import DatePicker from "react-datepicker";
import moment from "moment/moment";
import {fr} from 'date-fns/esm/locale';
import "react-datepicker/dist/react-datepicker.css";

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <span className="icon-arrow-down"></span>
        </components.DropdownIndicator>
    );
};

const Checkbox = (props) => (
    <input type="checkbox" {...props} inputmode='numeric'/>
);

const NumberInput = props => {
    const numeric = "numeric";
    this.setAttribute('inputmode','numeric');
    return <components.Input {...props} inputmode={numeric} />;
};

class FormComponent extends Component {
    constructor(props) {

        super(props);

        let insurees_data;

        // if ( this.props.insurees_data ) {
        //
        //     insurees_data = this.props.insurees_data;
        //
        // } else {

            insurees_data = {
                insuree_object: {
                    nationality: 'France',
                    age: null
                },
                dependents_array: [],
                destination_country: null,
                insurance_duration: '12>',
                insuree_has_cfe: 'NOT_KNOWN',
                date_of_subscription: moment().toDate()
            };

        // }

        this.state = {
            insurees_data: insurees_data,
            form_validation_error_detected: false,
            is_modal_visible: false,
            modal_content_type: null,
            contact_information_object: {
                email: null,
                phone: null,
                results_link: null
            },
            validation: false

        };

        this.handleChangeNationality = this.handleChangeNationality.bind(this);
        this.handleChangeAge = this.handleChangeAge.bind(this);
        this.handleChangeDependentsNationality = this.handleChangeDependentsNationality.bind(this);
        this.handleChangeDependentsAge = this.handleChangeDependentsAge.bind(this);
        this.handleChangeDestinationCountry = this.handleChangeDestinationCountry.bind(this);
        this.handleChangeInsuranceDuration = this.handleChangeInsuranceDuration.bind(this);
        this.handleChangeInsureeHasCfe = this.handleChangeInsureeHasCfe.bind(this);
        this.generateUrlWithMainFormData = this.generateUrlWithMainFormData.bind(this);
        this.handleGetAQuote = this.handleGetAQuote.bind(this);
        this.handleDeleteDependentItem = this.handleDeleteDependentItem.bind(this);
        this.handleAddDependentItem = this.handleAddDependentItem.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleChangeContactInformationEmail = this.handleChangeContactInformationEmail.bind(this);
        this.handleChangeContactInformationPhone = this.handleChangeContactInformationPhone.bind(this);
        this.onSendContactInformation = this.onSendContactInformation.bind(this);
        this.handleChangeDateOfSubscription = this.handleChangeDateOfSubscription.bind(this);
        this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);

    }




    handleChangeNationality(selected_option) {

        this.setState(prevState => ({
            insurees_data: {
                ...prevState.insurees_data,
                insuree_object: {
                    ...prevState.insurees_data.insuree_object,
                    nationality: selected_option.value
                }
            }
        }));

    };


    handleChangeAge(selected_option) {

        // перевірка чи не буде новий вік перевищувати допустипу кількість страших людей,
        // які вже добавлені у форму
        let adults_amount = getAdultsAmount(this.state.insurees_data, 'complex_array');
        let current_insuree_age = this.state.insurees_data.insuree_object.age;
        let selected_value;

        if ( selected_option.value > 26 ) {

            adults_amount++;

            if ( adults_amount > 2 && ( current_insuree_age === null || current_insuree_age <= 26 )) {

                this.handleShowModal('warning-message-adults-amount');
                selected_value = null;

            } else {

                selected_value = selected_option.value;

            }

        } else {

            selected_value = selected_option.value;

        }


        this.setState(prevState => ({
            insurees_data: {
                ...prevState.insurees_data,
                insuree_object: {
                    ...prevState.insurees_data.insuree_object,
                    age: selected_value
                }
            }
        }));

    };


    handleChangeDependentsNationality(position_in_list , selected_option) {

        let dependents_array = [...this.state.insurees_data.dependents_array];

        dependents_array[position_in_list].nationality = selected_option.value;


        this.setState(prevState => ({
            insurees_data: {
                ...prevState.insurees_data,
                dependents_array: dependents_array
            }
        }));

    };


    handleChangeDependentsAge(position_in_list, selected_option) {

        // перевірка чи не буде новий вік перевищувати допустипу кількість страших людей,
        // які вже добавлені у форму
        let adults_amount = getAdultsAmount(this.state.insurees_data, 'complex_array');
        let dependents_array = [...this.state.insurees_data.dependents_array];
        let current_dependent_age = dependents_array[position_in_list].age;

        if ( selected_option.value > 26 ) {

            adults_amount++;

            if ( adults_amount > 2 && ( current_dependent_age === null || current_dependent_age <= 26 )) {

                this.handleShowModal('warning-message-adults-amount');
                dependents_array[position_in_list].age = null;

            } else {

                dependents_array[position_in_list].age = selected_option.value;

            }

        } else {

            dependents_array[position_in_list].age = selected_option.value;

        }


        this.setState(prevState => ({
            insurees_data: {
                ...prevState.insurees_data,
                dependents_array: dependents_array
            }
        }));

    };


    handleChangeDestinationCountry(selected_option) {

        let main_insuree_nationality = this.state.insurees_data.insuree_object.nationality;
        let destination_country;

        if ( selected_option.value === main_insuree_nationality ) {

            this.handleShowModal('warning-message-expatriation-country');

            destination_country = null;

        } else {

            destination_country = selected_option.value;

        }

        this.setState(prevState => ({
            insurees_data: {
                ...prevState.insurees_data,
                destination_country: destination_country
            }
        }));

    };


    handleChangeInsuranceDuration(selected_option) {

        this.setState(prevState => ({
            insurees_data: {
                ...prevState.insurees_data,
                insurance_duration: selected_option.value
            }
        }));

    };


    handleChangeInsureeHasCfe(selected_option) {

        let input_value = selected_option.target.value;

        this.setState(prevState => ({
            insurees_data: {
                ...prevState.insurees_data,
                insuree_has_cfe: input_value
            }
        }));

    };


    handleAddDependentItem() {

        let dependents_array = [...this.state.insurees_data.dependents_array];

        dependents_array.push({
            nationality: this.state.insurees_data.insuree_object.nationality,
            age: null
        });


        this.setState(prevState => ({
            insurees_data: {
                ...prevState.insurees_data,
                dependents_array: dependents_array
            }
        }));


    }


    handleDeleteDependentItem(position_in_list) {


        let dependents_array = [...this.state.insurees_data.dependents_array];

        dependents_array.splice(position_in_list, 1);


        this.setState(prevState => ({
            insurees_data: {
                ...prevState.insurees_data,
                dependents_array: dependents_array
            }
        }));

    }

    onSendContactInformation(contact_information){
        this.props.onSendContactInformation(contact_information);
    }

    handleGetAQuote() {
        // TODO: Зробити толкову валідацію

        let not_valid_inputs_array = document.querySelectorAll('.mainPageFormContainer .not-valid-input');

        if ( not_valid_inputs_array.length > 0 ) {

            this.setState({ form_validation_error_detected: true });

            not_valid_inputs_array[0].scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});

        } else {



            this.props.onClearInsurancePlansArrayBeforeFetching();
            this.props.onSaveDataFromMainPageForm( this.state.insurees_data );
            let results_link = this.generateUrlWithMainFormData();


            this.handleChangeContactInformationResultLink(results_link);

            // console.log(results_link)

            window.open(results_link, "_blank") //to open new page
            // console.log(user_info);
            // console.log(this.state.contact_information_object);
        }

    }

    handleShowModal(content_type) {

        this.setState({
            is_modal_visible: true,
            modal_content_type: content_type
        });


        console.log(this.state.modal_content_type);
    }

    handleCloseModal() {

        this.setState({
            is_modal_visible: false,
            modal_content_type: null
        });

    }

    renderDependentsList() {


        let dependents_array = this.state.insurees_data.dependents_array;
        let insurees_data = this.state.insurees_data;


        if ( dependents_array.length > 0 ) {

            return this.state.insurees_data.dependents_array.map((item, index) => {

                return (

                    <Row key={index} className="insuranceRow dependentsItemRow">
                        <Col xs={7}>
                            <div className={`inputBox ${(insurees_data.dependents_array[index].nationality) ? "is-valid-input" : "not-valid-input" }`}>
                                <Select
                                    value={ NATIONALITY_OPTIONS.filter(option => option.value === insurees_data.dependents_array[index].nationality) }
                                    defaultValue={0}
                                    components={{ DropdownIndicator }}
                                    positionInList={0}
                                    classNamePrefix="insurance-main-select"
                                    className="select_nationality"
                                    onChange={this.handleChangeDependentsNationality.bind(this, index)}
                                    options={NATIONALITY_OPTIONS}
                                />
                            </div>
                        </Col>

                        <Col xs={3}>
                            <div className={`inputBox ${(insurees_data.dependents_array[index].age) ? "is-valid-input" : "not-valid-input" }`}>
                                <Select
                                    value={ AGE_OPTIONS.filter(option => option.value === insurees_data.dependents_array[index].age) }
                                    placeholder="0"
                                    components={{ DropdownIndicator }}
                                    classNamePrefix="insurance-main-select"
                                    onChange={this.handleChangeDependentsAge.bind(this, index)}
                                    options={AGE_OPTIONS}
                                />
                            </div>
                        </Col>

                        <Col xs={2}>
                            <button className="deleteDependentButton" onClick={this.handleDeleteDependentItem.bind(this, index)}>
                                <span className="icon-trash"></span>
                            </button>
                        </Col>
                    </Row>

                );

            });

        }

    }

    renderModalContent() {

        switch ( this.state.modal_content_type ) {
            case 'warning-message-expatriation-country':
                return (

                    <Modal
                        show={this.state.is_modal_visible}
                        onHide={this.handleCloseModal}
                        backdrop="static"
                        keyboard={false}
                        centered={true}
                        dialogClassName="warning-centered-modal">
                        <Modal.Header closeButton>
                            <Container className="defaultContainer">
                                {/*<button className="close-modal-button" variant="secondary" onClick={this.handleCloseModal}></button>*/}
                                <Modal.Title>
                                    <span className="icon-question"></span>
                                    <Trans i18nKey="modal_warning_message_expatriation_country_title"/>
                                </Modal.Title>
                            </Container>
                        </Modal.Header>
                        <Modal.Body>
                            <div><Trans i18nKey="modal_warning_message_expatriation_country_subtitle"/></div>
                            <button className="secondaryButtonStyle" onClick={this.handleCloseModal}><Trans i18nKey="modal_warning_message_button"/></button>
                        </Modal.Body>
                    </Modal>

                );

            case 'warning-message-adults-amount':
                return (

                    <Modal
                        show={this.state.is_modal_visible}
                        onHide={this.handleCloseModal}
                        backdrop="static"
                        keyboard={false}
                        centered={true}
                        dialogClassName="warning-centered-modal">
                        <Modal.Header closeButton>
                            <Container className="defaultContainer">
                                {/*<button className="close-modal-button" variant="secondary" onClick={this.handleCloseModal}></button>*/}
                                <Modal.Title>
                                    <span className="icon-question"></span>
                                    <Trans i18nKey="modal_warning_message_adults_amount_title"/>
                                </Modal.Title>
                            </Container>
                        </Modal.Header>
                        <Modal.Body>
                            {/*<div>Vous pouvez modifier votre choix pour accéder aux résultats.</div>*/}
                            <button className="secondaryButtonStyle" onClick={this.handleCloseModal}><Trans i18nKey="modal_warning_message_button"/></button>
                        </Modal.Body>
                    </Modal>

                );

            default:

                return null

        }

    }

    handleChangeContactInformationResultLink(changed_value) {

        this.setState(prevState => ({
            contact_information_object: {
                ...prevState.contact_information_object,
                results_link: changed_value
            }
        }), () => {
            let user_info = {
                insurees_data: this.state.insurees_data,
                contact_information: this.state.contact_information_object,
                conversion_URL: window.location.href
            }
            // console.log(user_info);

            var _hsq = window._hsq = window._hsq || [];
            _hsq.push(['setPath', user_info.conversion_URL]);
            _hsq.push(["identify",{
                email: user_info.contact_information.email,
                firstname: 'new widget',
                lastname: 'email' + (user_info.contact_information.phone ? "+ phone contact" : "  contact"),
                phone: user_info.contact_information.phone ? user_info.contact_information.phone : '',
                plan_search_results_link: user_info.contact_information.results_link,
                dur_e_du_contrat_souhait_: user_info.insurees_data.insurance_duration,
                adh_rent_cfe: user_info.insurees_data.insuree_has_cfe,
                leadin_pays_de_destination_bc1e211f71cc3f2e8346f8719273fb80:user_info.insurees_data.destination_country,
                leadin_pays_de_nationalitswb_0b819286eb1d5bab2234c31836f1e050: user_info.insurees_data.insuree_object.nationality,
                user_age_from_search: user_info.insurees_data.insuree_object.age,
                leadin_date_deffet_souhaiteu5b_14c8c5f2398e504ba9544393b9475d20: moment(user_info.insurees_data.date_of_subscription,).toDate().toLocaleDateString('en-GB'),
                dependents_array: JSON.stringify(user_info.insurees_data.dependents_array),
                url_where_widget_converted: user_info.conversion_URL
            }]);
            _hsq.push(['trackPageView']);

            console.log(user_info)

            this.onSendContactInformation(user_info);
        });
    };

    generateUrlWithMainFormData() {

        let urlWithMainFormData = "";

        if (this.state.insurees_data) {

            let APP_URL = "comparateur"
            if ((window.location.href.indexOf("/en/") > -1) || (window.location.href.indexOf("compare.") > -1) ) {
                APP_URL = "compare"
            } else if ((window.location.href.indexOf("/es/") > -1) || (window.location.href.indexOf("comparar.") > -1)) {
                APP_URL = "comparar"
            }

            // let urlWithMainFormData = window.location.host;


            urlWithMainFormData += `http://${APP_URL}.expat-assurance.com/`;
            // urlWithMainFormData += `https://ea-quote-ab-testing-staging.herokuapp.com/`;
            urlWithMainFormData += 'insurance?p=' + this.state.insurees_data.insuree_object.nationality + ',' + this.state.insurees_data.insuree_object.age;

            this.state.insurees_data.dependents_array.forEach((item) => {

                urlWithMainFormData += '&p=' + item.nationality + ',' + item.age

            });

            urlWithMainFormData += '&dc=' + this.state.insurees_data.destination_country;
            urlWithMainFormData += '&dur=' + this.state.insurees_data.insurance_duration;
            urlWithMainFormData += '&cfe=' + this.state.insurees_data.insuree_has_cfe;
            urlWithMainFormData += '&date=' + this.state.insurees_data.date_of_subscription;
            console.log(urlWithMainFormData)

        }
        return urlWithMainFormData;

    }


    handleChangeContactInformationPhone(changed_value) {

        let input_value = changed_value;

        this.setState(prevState => ({
                contact_information_object: {
                    ...prevState.contact_information_object,
                    phone: input_value
                }
        }));

    };

    handleChangeContactInformationEmail(changed_value) {

        let input_value = changed_value.target.value;

        this.setState(prevState => ({
            contact_information_object: {
                ...prevState.contact_information_object,
                email: input_value
            }
        }));

    };

    handleMobileButtonClick(){
        let hiddenElement = document.getElementById("mainFormBox");
        hiddenElement.scrollIntoView();
    }

    addNumpadForMobile(){
        let ageInput = document.getElementById('react-select-3-input');
        // console.log(ageInput)
        ageInput.setAttribute('inputmode','numeric');
    }

    handleChangeDateOfSubscription(changed_value) {

        this.setState(prevState => ({
            insurees_data: {
                ...prevState.insurees_data,
                date_of_subscription: changed_value
            }
        }));
    }


    handleChangeCheckbox(changed_value) {

        let isChecked = changed_value.target.checked;

        // console.log(isChecked)

        this.setState(prevState => ({
            ...prevState,
            validation: isChecked
        }));
    }



    render () {

        let contact_information_object = this.state.contact_information_object;
        let insurees_data = this.state.insurees_data;

        setTimeout(
        this.addNumpadForMobile,
        1000);

        return (
            <div>
                <div className="mobile_button" onClick={this.handleMobileButtonClick}>
                    Recervoir un devis
                    <img src={FormSelect} alt="FormSelect"/>
                </div>
            <div id="mainFormBox">

        <div
            className={`mainPageFormContainer ${(this.state.form_validation_error_detected) ? "form-validation-error" : null}`}>

            <div className="mainPageFormTitle">
                <Row>
                    <Col xs={2}>
                        <img src={TitleIcon} />
                    </Col>
                    <Col xs={10}>
                        {
                            ((window.location.href.indexOf("/es/") > -1) || (window.location.href.indexOf("comparar.") > -1))
                                 ? <h3 className="spanishTitle"><Trans i18nKey="global_variables_widget_title"/></h3>
                                 : <h3><Trans i18nKey="global_variables_widget_title"/></h3>

                        }
                    </Col>
                </Row>
            </div>
            {/*<Row className="formInfoBox">*/}
            {/*    <Col xs={2} className="formInfoBoxIcon">*/}
            {/*        <img src={InfoIcon} />*/}
            {/*    </Col>*/}
            {/*    <Col xs={10}>*/}
            {/*        <p>*/}
            {/*            <b>1.  <Trans i18nKey="global_variables_widget_info_1"/></b><br />*/}
            {/*            2. <Trans i18nKey="global_variables_widget_info_2"/><br />*/}
            {/*            3. <Trans i18nKey="global_variables_widget_info_3"/>*/}
            {/*        </p>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            <Row className="insuranceRow">

                <Col xs={7}>
                    <div
                        className={`inputBox ${(textInputValidation(insurees_data.insuree_object.nationality)) ? "is-valid-input" : "not-valid-input"}`}>
                        <label><Trans i18nKey="mainPage_form_nationality"></Trans><span className="red">*</span></label>
                        <Select
                            value={NATIONALITY_OPTIONS.filter(option => option.value === insurees_data.insuree_object.nationality)}
                            components={{DropdownIndicator}}
                            positionInList={0}
                            placeholder={i18n.t("global_select")}
                            classNamePrefix="insurance-main-select"
                            className="select_nationality"
                            onChange={this.handleChangeNationality}
                            options={NATIONALITY_OPTIONS}
                        />
                    </div>
                </Col>

                <Col xs={3}>
                    <div className={`inputBox ${(insurees_data.insuree_object.age) ? "is-valid-input" : "not-valid-input"}`}>
                        <label><Trans i18nKey="mainPage_form_age"></Trans><span className="red">*</span></label>
                        <Select
                            value={AGE_OPTIONS.filter(option => option.value === insurees_data.insuree_object.age)}
                            placeholder="18"
                            components={{DropdownIndicator}}
                            classNamePrefix="insurance-main-select"
                            onChange={this.handleChangeAge}
                            options={AGE_OPTIONS}

                        />
                    </div>
                </Col>

                <Col xs={2}>
                    <button className="addDependentsButton" onClick={this.handleAddDependentItem}>
                        <span className="icon-user"></span> <Trans i18nKey="mainPage_form_add_person"></Trans>
                    </button>
                </Col>


            </Row>

            <div className="dependentsContainer">

                {this.renderDependentsList()}

            </div>

            <Row>

                <Col xs={12}>
                    <div className={`inputBox ${(insurees_data.destination_country) ? "is-valid-input" : "not-valid-input"}`}>
                        <label>
                            <Trans i18nKey="mainPage_form_country_emigration"></Trans>
                            <span className="red">*</span>
                            <Tooltip
                                tooltipId="main_cfe"
                                tooltipType="light"
                                tooltipEffect="solid"
                                tooltipIconSize={16}
                                tooltipIconTopPosition={2}
                                tooltipIconOffset={5}
                                tooltipContent={i18n.t("mainPage_form_country_emigration_select_tooltip")}
                            />
                        </label>
                        <Select
                            value={DESTINATION_COUNTRY_OPTIONS.filter(option => option.value === insurees_data.destination_country)}
                            components={{DropdownIndicator}}
                            placeholder={i18n.t("mainPage_form_country_emigration_select")}
                            classNamePrefix="insurance-main-select"
                            onChange={this.handleChangeDestinationCountry}
                            options={DESTINATION_COUNTRY_OPTIONS}
                        />
                    </div>
                </Col>

            </Row>

            <Row>

                <Col xs={12} className={"noDisplay"}>
                    <div className={`inputBox ${(insurees_data.insurance_duration) ? "is-valid-input" : "not-valid-input"}`}>
                        <label><Trans i18nKey="mainPage_form_time"></Trans></label>
                        <Select
                            value={INSURANCE_DURATION_OPTIONS.filter(option => option.value === insurees_data.insurance_duration)}
                            components={{DropdownIndicator}}
                            classNamePrefix="insurance-main-select"
                            onChange={this.handleChangeInsuranceDuration}
                            options={INSURANCE_DURATION_OPTIONS}
                            isSearchable={false}
                        />
                    </div>
                </Col>

            </Row>

            <Row>

                <Col xs={12} className={"noDisplay"}>
                    <div className="inputBox radioInputBox">
                        <label>
                            <Trans i18nKey="mainPage_form_cfe_coverege"></Trans>
                            <Tooltip
                                tooltipId="main_cfe"
                                tooltipType="light"
                                tooltipEffect="solid"
                                tooltipIconSize={16}
                                tooltipIconTopPosition={2}
                                tooltipIconOffset={5}
                                tooltipContent={i18n.t("mainPage_cfe_coverege_i")}
                            />
                        </label>

                        <Row className="radioBlockRow">

                            <Col xs={3}>
                                <input
                                    type="radio"
                                    id="insuree_has_cfe_yes"
                                    value="YES"
                                    name="cfe_radio"
                                    defaultChecked={(insurees_data.insuree_has_cfe === "YES") ? true : false}
                                    onChange={this.handleChangeInsureeHasCfe}
                                />
                                <label htmlFor="insuree_has_cfe_yes"><Trans i18nKey="mainPage_form_cfe_yes"></Trans></label>
                            </Col>
                            <Col xs={3} className="mediumRadioCol">
                                <input
                                    type="radio"
                                    id="insuree_has_cfe_no"
                                    value="NO"
                                    name="cfe_radio"
                                    defaultChecked={(insurees_data.insuree_has_cfe === "NO") ? true : false}
                                    onChange={this.handleChangeInsureeHasCfe}
                                />
                                <label htmlFor="insuree_has_cfe_no"><Trans i18nKey="mainPage_form_cfe_no"></Trans></label>
                            </Col>
                            <Col xs={6}>
                                <input
                                    type="radio"
                                    id="insuree_has_cfe_not_know"
                                    value="NOT_KNOWN"
                                    name="cfe_radio"
                                    defaultChecked={(insurees_data.insuree_has_cfe === "NOT_KNOWN") ? true : false}
                                    onChange={this.handleChangeInsureeHasCfe}
                                />
                                <label htmlFor="insuree_has_cfe_not_know"><Trans i18nKey="mainPage_form_cfe_dont_know"></Trans></label>
                            </Col>

                        </Row>

                    </div>
                </Col>

            </Row>

            <Row className="insuranceRow">
                <Col xs={12}>
                    <div className={`inputBox ${(emailInputValidation(contact_information_object.email)) ? "is-valid-input" : "not-valid-input" }`}>
                        <label><Trans i18nKey="getPlanePage_subscribe_form_email"/><span className="red">*</span></label>
                        <input
                            type="text"
                            placeholder={i18n.t("global_your_email_placeholder")}
                            defaultValue={contact_information_object.email}
                            onChange={this.handleChangeContactInformationEmail}
                        />
                    </div>
                </Col>

                {/*<Col xs={12}>*/}
                {/*    <div className={`inputBox ${(contact_information_object.phone) ? "is-valid-input" : "not-valid-input" }`}>*/}
                {/*        <label><Trans i18nKey="getPlanePage_subscribe_form_phone"/><span className="red">*</span></label>*/}
                {/*        <PhoneInput*/}
                {/*            country={'fr'}*/}
                {/*            placeholder="+33 1 09 75 83 51"*/}
                {/*            defaultValue={contact_information_object.phone}*/}
                {/*            onChange={this.handleChangeContactInformationPhone}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</Col>*/}
            </Row>
            {}
            <Row className={(window.location.href.indexOf("/fr/") > -1) ? "" : 'noDisplay'}>

                <Col xs={12} className="dateInputCol">
                    <div className={`inputBox`}>
                        <label>Date d'effet souhaitée<span className="red">*</span></label>
                        <DatePicker
                            minDate={moment().toDate()}
                            calendarClassName="insurance-main-datepicker"
                            locale={fr}
                            dateFormat="dd/MM/yyyy"
                            onFocus={(e) => e.target.readOnly = true}
                            placeholderText={moment(new Date()).format("DD/MM/YYYY")}
                            selected={this.state.insurees_data.date_of_subscription ?  moment(this.state.insurees_data.date_of_subscription).toDate() : moment().toDate()}
                            onChange={this.handleChangeDateOfSubscription}
                        />
                    </div>
                </Col>

            </Row>
            <Row>
                <Col xs={12} className={`checkboxCol ${ this.state.validation === true ? "is-valid-input" : "not-valid-input"}`}>
                    <div className="checkboxColDiv checkbox-wrapper-13">
                        <Checkbox
                            id="legal"
                            onChange={this.handleChangeCheckbox}
                        />
                    </div>
                    <div className="checkboxColDiv">
                        <label for="legal">
                            <Trans i18nKey="legal_checkbox"/>
                        </label>
                    </div>
                </Col>
            </Row>

            <Row>

                <button className="mainButtonStyle handleGetAQuoteButton" onClick={this.handleGetAQuote}>
                    <Trans i18nKey="mainPage_form_submit_button"></Trans> <span className="icon-big-arrow-right"></span>
                </button>

            </Row>
            <Row>
                <Col xs={12} className="legalCol">
                    <p>
                        <Trans i18nKey="legal_text"/> <a href={i18n.t("legal_link")} target="_blank"> <Trans i18nKey="legal_link_text"/></a>.
                    </p>
                </Col>
            </Row>

        </div>

            </div>
                { this.renderModalContent() }
            </div>

        )
    }
};

export default withRouter(connect(
    state => ({
        insurees_data: state.main_form_data.insurees_data
    }),
    dispatch => ({
        onSaveDataFromMainPageForm: (main_form_data_object) => {
            dispatch(saveDataFromMainPageForm(main_form_data_object));
        },
        onClearInsurancePlansArrayBeforeFetching: () => {
            dispatch(clearInsurancePlansArrayBeforeFetching());
        },
        onSendContactInformation: (contact_information) => {
            dispatch(sendContactInformation(contact_information));
        }
    })
)(FormComponent));
